import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09cbf3ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-left-arrow" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right-arrow" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "actions-bar" }
const _hoisted_7 = { class: "image-counter" }

import TUIEnv from '../../../../../TUIPlugin/TUIEnv';
import { ref, watchEffect, onMounted, onUnmounted } from 'vue';
import { Message } from '../../interface';
import { isNumber } from '@vueuse/core';
interface touchesPosition {
  pageX1?: number;
  pageY1?: number;
  pageX2?: number;
  pageY2?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'imagePreviewer',
  props: {
  imageList: {
    type: Array,
    default: () => [] as Array<Message>,
  },
  currentImage: {
    type: Object,
    default: () => ({} as Message),
  },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const zoom = ref(1);
const rotate = ref(0);
const minZoom = ref(0.1);
const currentImageIndex = ref(0);
const image = ref();
const ul = ref();
const { isH5 } = TUIEnv();
// touch
let startX = 0;
let touchStore = {} as touchesPosition;
let moveFlag = false;
let twoTouchesFlag = false;
let timer: number | null = null;

watchEffect(() => {
  currentImageIndex.value = props.imageList.findIndex((message: any) => {
    return message.ID === props.currentImage.ID;
  });
});

const debounce = (func: any, wait = 200) => {
  let timer: any;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, wait);
  };
};

const handleTouchStart = (e: any) => {
  e.preventDefault();
  moveInit(e);
  twoTouchesInit(e);
};

const handleTouchMove = (e: any) => {
  e.preventDefault();
  moveFlag = true;
  if (e.touches && e.touches.length === 2) {
    twoTouchesFlag = true;
    handleTwoTouches(e);
  }
};

const handleTouchEnd = (e: any) => {
  e.preventDefault();
  let moveEndX = 0;
  let X = 0;
  if (twoTouchesFlag) {
    if (!timer) {
      twoTouchesFlag = false;
      delete touchStore.pageX2;
      delete touchStore.pageY2;
      timer = setTimeout(() => {
        timer = null;
      }, 200);
    }
    return;
  }
  // H5 touch move to left to go to prev image
  // H5 touch move to right to go to next image
  if (timer === null) {
    switch (moveFlag) {
      // touch event
      case true:
        moveEndX = e?.changedTouches[0]?.pageX;
        X = moveEndX - startX;
        if (X > 100) {
          goPrev();
        } else if (X < -100) {
          goNext();
        }
        break;
      // click event
      case false:
        close();
        break;
    }
    timer = setTimeout(() => {
      timer = null;
    }, 200);
  }
};

const handleTouchCancel = (e: any) => {
  twoTouchesFlag = false;
  delete touchStore.pageX1;
  delete touchStore.pageY1;
};

const handleWheel = (e: any) => {
  e.preventDefault();
  if (Math.abs(e.deltaX) !== 0 && Math.abs(e.deltaY) !== 0) return;
  let scale = zoom.value;
  scale += e.deltaY * (e.ctrlKey ? -0.01 : 0.002);
  scale = Math.min(Math.max(0.125, scale), 4);
  zoom.value = scale;
};

const moveInit = (e: any) => {
  startX = e?.changedTouches[0]?.pageX;
  moveFlag = false;
};

const twoTouchesInit = (e: any) => {
  let touch1 = e?.touches[0];
  let touch2 = e?.touches[1];
  touchStore.pageX1 = touch1?.pageX;
  touchStore.pageY1 = touch1?.pageY;
  if (touch2) {
    touchStore.pageX2 = touch2?.pageX;
    touchStore.pageY2 = touch2?.pageY;
  }
};

const handleTwoTouches = (e: any) => {
  let touch1 = e?.touches[0];
  let touch2 = e?.touches[1];
  if (touch2) {
    if (!isNumber(touchStore.pageX2)) {
      touchStore.pageX2 = touch2.pageX;
    }
    if (!isNumber(touchStore.pageY2)) {
      touchStore.pageY2 = touch2.pageY;
    }
  }
  const getDistance = (startX: number, startY: number, stopX: number, stopY: number) => {
    return Math.hypot(stopX - startX, stopY - startY);
  };
  if (
    !isNumber(touchStore.pageX1) ||
    !isNumber(touchStore.pageY1) ||
    !isNumber(touchStore.pageX2) ||
    !isNumber(touchStore.pageY2)
  ) {
    return;
  }
  let touchZoom =
    getDistance(touch1.pageX, touch1.pageY, touch2.pageX, touch2.pageY) /
    getDistance(touchStore.pageX1, touchStore.pageY1, touchStore.pageX2, touchStore.pageY2);
  zoom.value = Math.min(Math.max(0.5, zoom.value * touchZoom), 4);
};

onMounted(() => {
  image?.value?.addEventListener('touchstart', handleTouchStart);
  image?.value?.addEventListener('touchmove', handleTouchMove);
  image?.value?.addEventListener('touchend', handleTouchEnd);
  image?.value?.addEventListener('touchcancel;', handleTouchCancel);
  // web: mouse wheel & mac wheel
  image?.value?.addEventListener('wheel', handleWheel);
  // web: close on esc keydown
  document?.addEventListener('keydown', handleEsc);
});

const handleEsc = (e: any) => {
  e.preventDefault();
  if (e?.keyCode === 27) {
    close();
  }
};
const zoomIn = () => {
  zoom.value += 0.1;
};
const zoomOut = () => {
  zoom.value = zoom.value - 0.1 > minZoom.value ? zoom.value - 0.1 : minZoom.value;
};
const close = () => {
  emit('close');
};
const rotateLeft = () => {
  rotate.value -= 90;
};
const rotateRight = () => {
  rotate.value += 90;
};
const goNext = () => {
  ul.value.style.transition = '0.5s';
  currentImageIndex.value < props.imageList.length - 1 && currentImageIndex.value++;
  initStyle();
};
const goPrev = () => {
  ul.value.style.transition = '0.5s';
  currentImageIndex.value > 0 && currentImageIndex.value--;
  initStyle();
};
const initStyle = () => {
  zoom.value = 1;
  rotate.value = 0;
};

onUnmounted(() => {
  image?.value?.removeEventListener('touchstart', handleTouchStart);
  image?.value?.removeEventListener('touchmove', handleTouchMove);
  image?.value?.removeEventListener('touchend', handleTouchEnd);
  image?.value?.removeEventListener('touchcancel;', handleTouchCancel);
  image?.value?.removeEventListener('wheel', handleWheel);
  document?.removeEventListener('keydown', handleEsc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["image-previewer", [_unref(isH5) && 'image-previewer-h5']])
  }, [
    _createElementVNode("div", {
      class: "image-wrapper",
      ref_key: "image",
      ref: image
    }, [
      _createElementVNode("ul", {
        class: "image-list",
        style: _normalizeStyle({
          width: `${__props.imageList.length * 100}%`,
          transform: `translateX(-${(currentImageIndex.value * 100) / __props.imageList.length}%)`,
        }),
        ref_key: "ul",
        ref: ul
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imageList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "image-item",
            key: index
          }, [
            _createElementVNode("img", {
              class: "image-preview",
              style: _normalizeStyle({
              transform: `scale(${zoom.value}) rotate(${rotate.value}deg)`,
            }),
              src: item?.payload?.imageInfoArray[0]?.url
            }, null, 12, _hoisted_1)
          ]))
        }), 128))
      ], 4)
    ], 512),
    _withDirectives(_createElementVNode("i", {
      class: "icon icon-close",
      onClick: close
    }, null, 512), [
      [_vShow, !_unref(isH5)]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "image-button image-button-left",
      onClick: goPrev
    }, _hoisted_3, 512), [
      [_vShow, !_unref(isH5) && currentImageIndex.value > 0]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "image-button image-button-right",
      onClick: goNext
    }, _hoisted_5, 512), [
      [_vShow, !_unref(isH5) && currentImageIndex.value < __props.imageList?.length - 1]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("i", {
        class: "icon icon-zoom-in",
        onClick: zoomIn
      }),
      _createElementVNode("i", {
        class: "icon icon-zoom-out",
        onClick: zoomOut
      }),
      _createElementVNode("i", {
        class: "icon icon-refresh-left",
        onClick: rotateLeft
      }),
      _createElementVNode("i", {
        class: "icon icon-refresh-right",
        onClick: rotateRight
      }),
      _createElementVNode("span", _hoisted_7, _toDisplayString(currentImageIndex.value + 1) + " / " + _toDisplayString(__props.imageList.length), 1)
    ])
  ], 2))
}
}

})